var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c(_vm.activeComponent,_vm._b({tag:"component",on:{"next":_vm.onNext}},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }